var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.039,
    height: 20,
    viewBox: "0 0 18.039 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#455079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-675.295 -434.268)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M691.674,449.084a1,1,0,0,0-1.413-.007l-.007.007-.29.3V446.79a1,1,0,0,0-2,0v2.594l-.29-.3a1,1,0,0,0-1.42,1.42l2,2a1,1,0,0,0,.33.21.942.942,0,0,0,.76,0,.988.988,0,0,0,.33-.21l2-2a1,1,0,0,0,.007-1.413Z",
    transform: "translate(1.364 1.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M691.231,440.94v-.09a1.073,1.073,0,0,0-.189-.28l-6-6a1.074,1.074,0,0,0-.28-.189.3.3,0,0,0-.1,0,1.089,1.089,0,0,0-.31-.113h-6.06a3,3,0,0,0-3,3v14a3,3,0,0,0,3,3h10.018l-1.491-1.491a2.132,2.132,0,0,1,1.379-3.635v-.876a2.13,2.13,0,0,1,2.128-2.127,2.1,2.1,0,0,1,.962.24v-5.168A1.3,1.3,0,0,0,691.231,440.94Zm-11.713-.67h1a1,1,0,1,1,0,2h-1a1,1,0,0,1,0-2Zm4,10h-4a1,1,0,0,1,0-2h4a1,1,0,1,1,0,2Zm2-4h-6a1,1,0,0,1,0-2h6a1,1,0,1,1,0,2Zm.776-5.995a1,1,0,0,1-1-1V437.68l2.594,2.594Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.911191ce6a5c05e52b46bb8bcb3975c5.svg";
export { ForwardRef as ReactComponent };